import React, { useState } from 'react';
import { Zap } from 'lucide-react';
import AskNiwtcoDrawer from './AskNiwtcoDrawer';

const AskNiwtcoBar: React.FC = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <>
      <div className="bg-gradient-to-r from-niwt-primary to-niwt-secondary">
        <div className="max-w-7xl mx-auto px-4 py-2.5 flex items-center justify-between">
          <div className="flex items-center gap-2 text-white/80 text-xs">
            <Zap className="w-3.5 h-3.5 text-white" />
            <span>Niwtco is ready · 94% data coverage</span>
          </div>
          <button
            onClick={() => setDrawerOpen(true)}
            className="flex items-center gap-2 bg-white/15 hover:bg-white/25 text-white text-sm font-medium px-4 py-1.5 rounded-full transition-colors border border-white/20"
          >
            <Zap className="w-3.5 h-3.5" />
            Ask Niwtco: What should we do next?
          </button>
        </div>
      </div>

      {drawerOpen && <AskNiwtcoDrawer onClose={() => setDrawerOpen(false)} />}
    </>
  );
};

export default AskNiwtcoBar;
